import React, { PropTypes, Component } from 'react'
import DataTable from 'components/dataTable'
import styles from './styles'
import misc from 'utils/misc'
import AutoComplete from 'components/autocomplete'

export default class NewDataInput extends Component {
  static propTypes = {
    schema: PropTypes.object.isRequired,
    value: PropTypes.string.isRequired,
    onDataUpdate: PropTypes.func,
  };

  constructor (props, context) {
    super(props, context)
    this.onChange = (e) => this.props.onDataUpdate(this.props.schema.key, e.target.value)
    this.onSelect = (item, i) => {
      const keys = Object.keys(this.props.schema.map)
      this.props.onDataUpdate(this.props.schema.key, keys[i])
    }
  }

  shouldComponentUpdate (nextProps) {
    return (!misc.isObjectEqual(this.props, nextProps))
  }

  render () {
    const schema = this.props.schema
    let input = null
    const inputProps = {}
    inputProps.className = styles.newDataInput
    inputProps.placeholder = `輸入${schema.title}`
    inputProps.value = this.props.value
    inputProps.onChange = this.onChange
    inputProps.onKeyDown = e => {
      const code = e.keyCode || e.which
      if (code === 13) {
        e.preventDefault()
        return false
      }
    }

    switch (schema.type) {
      case DataTable.CellType.password:
        inputProps.type = 'password'
        input = <input {...inputProps} />
        break
      case DataTable.CellType.date:
      case DataTable.CellType.text:
      case DataTable.CellType.input:
        inputProps.type = 'text'
        input = <input {...inputProps} />
        break
      case DataTable.CellType.autoComplete:
        input = (
          <AutoComplete
            items={misc.objectValues(schema.map)}
            placeholder={inputProps.placeholder}
            onSelect={this.onSelect}
            value={schema.map[this.props.value]}
            expand
          />
        )
        break
      case DataTable.CellType.dropDown:
        inputProps.placeholder = `選擇${schema.title}`
        input = (
          <AutoComplete
            items={misc.objectValues(schema.map)}
            placeholder={inputProps.placeholder}
            onSelect={this.onSelect}
            value={schema.map[this.props.value]}
            expand
            dropDown
          />
        )
        break
      default:
    }

    return (
      <div className={styles.newDataRow} >
        {input}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/components/dataSyncTable/newDataInput.jsx